module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-01-429dad328ed1b28312085f25b8dae3df.jpg";